import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Student Attendance Analytics — Owner
 * GET /student-attendance/analytics?period=&classId=&sectionId=
 */
export const getStudentAttendanceAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/student-attendance/analytics", {
    params,
  });
  return res.data;
};

/**
 * Student Attendance Analytics — Portal
 * GET /student-attendance-portal/analytics?period=&classId=&sectionId=
 */
export const getStudentAttendanceAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/student-attendance-portal/analytics", {
    params,
  });
  return res.data;
};
